import { ToastModule } from 'primeng/toast';

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SvgIcon } from '@shared/ui/svg-icon';

@Component({
  selector: 'app-toast',
  imports: [ToastModule, SvgIcon],
  templateUrl: './toast.html',
  styleUrl: './toast.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Toast {}
